import moment from 'moment'
import { formatPhoneNumber } from 'app/formatPhoneNumber'
import type { Activity } from 'app/generated/graphql'

const HOURS_SHOWN_RELATIVE = 24
const SNIPPET_LENGTH = 80

/** "2h ago" inside a day, a short date after that. */
export function activityWhenLabel(iso: string | null | undefined): string {
  if (!iso) return ``
  const when = moment(iso)
  return moment().diff(when, `hours`) < HOURS_SHOWN_RELATIVE ? when.fromNow() : when.format(`MMM D`)
}

export function activityPersonLabel(activity: Activity): string {
  return (
    activity.contactName ||
    activity.nameFromActivity ||
    formatPhoneNumber(activity.contactPhone || activity.phoneFromActivity || undefined) ||
    `Unknown caller`
  )
}

/** One line of a message, whitespace collapsed, cut to fit a result row. */
export function messageSnippet(text: string | null | undefined): string {
  const flat = (text ?? ``).replace(/\s+/g, ` `).trim()
  return flat.length > SNIPPET_LENGTH ? `${flat.slice(0, SNIPPET_LENGTH - 1)}…` : flat
}
